module.exports = __webpack_public_path__ + "bb1f080bc888b86c8c92adb91ecba9cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/dan-abramov.jpg
// module id = 510
// module chunks = 0